export default {
  total: "Gesamt",
  buttons: {
    add_items: 'Mehr Bestellen',
  },
};
